import './utils/class-component-hooks';
import './registerServiceWorker';
import 'bootstrap';
import './styles/custom.scss';
import { Log } from 'oidc-client-ts';
import Vue from 'vue';
// eslint-disable-next-line sort-imports
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Log.setLogger(console);
Log.setLevel(Log.INFO);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
